import {
  PROVIDERS_FETCHED_SUCCESS,
  PROVIDERS_FETCHED_FAILURE,
} from './types';
import { logger } from '../logger';

const log = logger();

const providersFetchedAction = (status) => async (dispatch) => {
  try {
    dispatch({
      type: PROVIDERS_FETCHED_SUCCESS,
      payload: status,
    });
  } catch (err) {
    log.error('Error dispatching providers fetched action', err);
    dispatch({
      type: PROVIDERS_FETCHED_FAILURE,
      payload: status,
    });
  }
};

export default providersFetchedAction;
